<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Withdrawal History</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="!loading && items.length === 0" class="empty">
    <ion-icon name="receipt-outline" size="large"></ion-icon>
    <p>No withdrawal requests yet.</p>
  </div>

  <ion-list>
    <ion-item *ngFor="let s of items">
      <ion-label>
        <h2>${{ s.valorSolicitado | number:'1.2-2' }}<span *ngIf="s.valorEfetivamentePago != null"> &mdash; paid ${{ s.valorEfetivamentePago | number:'1.2-2' }}</span></h2>
        <p>{{ s.metodoRecebimento }} <span *ngIf="s.saqueManualSemTaxa">(no fee)</span></p>
        <p>Requested {{ s.dataSolicitacao | date:'MMM d, y, h:mm a' }}</p>
        <p *ngIf="s.dataPagamento">Paid {{ s.dataPagamento | date:'MMM d, y, h:mm a' }}</p>
      </ion-label>
      <ion-badge slot="end" [color]="statusColor(s.status)">{{ s.status }}</ion-badge>
    </ion-item>
  </ion-list>
</ion-content>
